import Badge from '../../badge';

interface NotificationType {
  isModalOpen: boolean;
  openModal: () => void;
  NotificationCount?: number;
  id?: string;
}

const Notification = ({
  NotificationCount,
  isModalOpen,
  openModal,
  id,
}: NotificationType): JSX.Element => {
  return (
    <Badge
      variant='primary'
      icon='notifications'
      count={NotificationCount}
      isActive={isModalOpen}
      onClick={() => {
        openModal();
      }}
      id={id}
    />
  );
};

export default Notification;
